<div class="meeting-join-sidebar">
  <div class="unit">
    <app-meeting-join-widget></app-meeting-join-widget>
  </div>
</div>
